import {
  ADD_LOSS_PERCENTAGE_FAIL,
  ADD_LOSS_PERCENTAGE_REQUEST,
  ADD_LOSS_PERCENTAGE_SUCCESS,
  COMPLETE_OPERATION_WITHOUT_WEIGHT2_FAIL,
  COMPLETE_OPERATION_WITHOUT_WEIGHT2_REQUEST,
  COMPLETE_OPERATION_WITHOUT_WEIGHT2_SUCCESS,
  COMPLETE_OPERATION_WITH_TECH_PASS_WEIGHT_FAIL,
  COMPLETE_OPERATION_WITH_TECH_PASS_WEIGHT_REQUEST,
  COMPLETE_OPERATION_WITH_TECH_PASS_WEIGHT_SUCCESS,
  GET_OPERATIONS_FOR_CUSTOMER_FAIL,
  GET_OPERATIONS_FOR_CUSTOMER_REQUEST,
  GET_OPERATIONS_FOR_CUSTOMER_SUCCESS,
  GET_OPERATIONS_LIST_FAIL,
  GET_OPERATIONS_LIST_REQUEST,
  GET_OPERATIONS_LIST_SUCCESS,
  GET_OPERATION_FILE,
  GET_OPERATION_FILE_FAIL,
  GET_OPERATION_FILE_SUCCESS,
  GET_OP_READ_WEIGHT_FAIL,
  GET_OP_READ_WEIGHT_REQUEST,
  GET_OP_READ_WEIGHT_SUCCESS,
  GET_OP_TRB_WEIGHT_FAIL,
  GET_OP_TRB_WEIGHT_REQUEST,
  GET_OP_TRB_WEIGHT_SUCCESS,
  GET_SINGLE_OPERATION_FAIL,
  GET_SINGLE_OPERATION_REQUEST,
  GET_SINGLE_OPERATION_SUCCESS,
  GET_WEIGHT_FAIL,
  GET_WEIGHT_REQUEST,
  GET_WEIGHT_SUCCESS,
  OPERATION_CHANGE_APPROVE_FAIL,
  OPERATION_CHANGE_APPROVE_REQUEST,
  OPERATION_CHANGE_APPROVE_SUCCESS,
  OPERATION_CHANGE_CANCEL_FAIL,
  OPERATION_CHANGE_CANCEL_REQUEST,
  OPERATION_CHANGE_CANCEL_SUCCESS,
  OPERATION_DELETE_APPROVE_FAIL,
  OPERATION_DELETE_APPROVE_REQUEST,
  OPERATION_DELETE_APPROVE_SUCCESS,
  OPERATION_DELETE_CANCEL_FAIL,
  OPERATION_DELETE_CANCEL_REQUEST,
  OPERATION_DELETE_CANCEL_SUCCESS,
  RESET_SINGLE_OPERATION,
  RESET_WEIGHT,
  SUBMIT_OPERATION_FAIL,
  SUBMIT_OPERATION_REQUEST,
  SUBMIT_OPERATION_SUCCESS,
  UPDATE_OPERATION_FAIL,
  UPDATE_OPERATION_REQUEST,
  UPDATE_OPERATION_SUCCESS,
  UPLOAD_IMAGE_FAIL,
  UPLOAD_IMAGE_REQUEST,
  UPLOAD_IMAGE_SUCCESS,
} from "src/constants/types";

export const operationReducers = (state = { weight: 0 }, actions) => {
  const { payload } = actions;
  switch (actions.type) {
    case UPLOAD_IMAGE_REQUEST:
      return {
        ...state,
        loadingImage: true,
        error: "",
      };
    case UPLOAD_IMAGE_SUCCESS:
      return {
        ...state,
        loadingImage: false,
        error: "",
      };
    case UPLOAD_IMAGE_FAIL:
      return {
        ...state,
        loadingImage: false,
        error: actions.payload,
      };

    case SUBMIT_OPERATION_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case SUBMIT_OPERATION_SUCCESS:
      return {
        ...state,
        loading: false,
        error: "",
      };
    case SUBMIT_OPERATION_FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
      };

    case UPDATE_OPERATION_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case UPDATE_OPERATION_SUCCESS:
      return {
        ...state,
        loading: false,
        error: "",
      };
    case UPDATE_OPERATION_FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
      };

    case RESET_SINGLE_OPERATION:
      return {
        ...state,
        single_operation: "",
      };

    case GET_WEIGHT_REQUEST:
      return {
        ...state,
      };
    case GET_WEIGHT_SUCCESS:
      return {
        ...state,
        weight: payload,
      };
    case GET_WEIGHT_FAIL:
      return {
        ...state,
      };

    case GET_OP_READ_WEIGHT_REQUEST:
      return {
        ...state,
      };
    case GET_OP_READ_WEIGHT_SUCCESS:
      return {
        ...state,
        weight: payload,
      };
    case GET_OP_READ_WEIGHT_FAIL:
      return {
        ...state,
      };

    case GET_OP_TRB_WEIGHT_REQUEST:
      return {
        ...state,
      };
    case GET_OP_TRB_WEIGHT_SUCCESS:
      return {
        ...state,
        weight: payload,
      };
    case GET_OP_TRB_WEIGHT_FAIL:
      return {
        ...state,
      };

    case RESET_WEIGHT:
      return {
        ...state,
        weight: 0,
      };

    case GET_OPERATIONS_LIST_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case GET_OPERATIONS_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        operationList: payload,
      };
    case GET_OPERATIONS_LIST_FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
      };

    case GET_OPERATIONS_FOR_CUSTOMER_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case GET_OPERATIONS_FOR_CUSTOMER_SUCCESS:
      return {
        ...state,
        loading: false,
        operationsForCustomer: payload,
      };
    case GET_OPERATIONS_FOR_CUSTOMER_FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
      };

    case GET_SINGLE_OPERATION_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case GET_SINGLE_OPERATION_SUCCESS:
      return {
        ...state,
        single_operation: payload,
        error: "",
        loading: false,
      };
    case GET_SINGLE_OPERATION_FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
      };

    case GET_OPERATION_FILE:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case GET_OPERATION_FILE_SUCCESS:
      return {
        ...state,
        loading: false,
        file: payload,
      };
    case GET_OPERATION_FILE_FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
      };

    case OPERATION_CHANGE_APPROVE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case OPERATION_CHANGE_APPROVE_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case OPERATION_CHANGE_APPROVE_FAIL:
      return {
        ...state,
        loading: false,
      };

    case OPERATION_CHANGE_CANCEL_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case OPERATION_CHANGE_CANCEL_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case OPERATION_CHANGE_CANCEL_FAIL:
      return {
        ...state,
        loading: false,
      };

    case OPERATION_DELETE_APPROVE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case OPERATION_DELETE_APPROVE_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case OPERATION_DELETE_APPROVE_FAIL:
      return {
        ...state,
        loading: false,
      };

    case OPERATION_DELETE_CANCEL_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case OPERATION_DELETE_CANCEL_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case OPERATION_DELETE_CANCEL_FAIL:
      return {
        ...state,
        loading: false,
      };

    case COMPLETE_OPERATION_WITHOUT_WEIGHT2_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case COMPLETE_OPERATION_WITHOUT_WEIGHT2_SUCCESS:
      return {
        ...state,
        loading: false,
      };

    case COMPLETE_OPERATION_WITHOUT_WEIGHT2_FAIL:
      return {
        ...state,
        loading: false,
      };

    case COMPLETE_OPERATION_WITH_TECH_PASS_WEIGHT_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case COMPLETE_OPERATION_WITH_TECH_PASS_WEIGHT_SUCCESS:
      return {
        ...state,
        loading: false,
      };

    case COMPLETE_OPERATION_WITH_TECH_PASS_WEIGHT_FAIL:
      return {
        ...state,
        loading: false,
      };

    case ADD_LOSS_PERCENTAGE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case ADD_LOSS_PERCENTAGE_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case ADD_LOSS_PERCENTAGE_FAIL:
      return {
        ...state,
        loading: false,
      };

    default:
      return state;
  }
};
